import { defineStore } from 'pinia';

import { useBuildingDetails } from '@/composables/useBuildingDetails.js';
import { pakketStore } from '@/stores/pakket.js';
import { verzekeringStore } from '@/stores/verzekering.js';

export const vragenStore = defineStore({
  id: 'vragen',
  state: () => ({
    voertuig: {
      AanrijdingMeeverzekeren: '',
      Aanschafwaarde: '',
      AantalKmPerJaar: '',
      AantalSchadevrijeJaren: '',
      AantalSchadevrijeJarenEersteAuto: '',
      Aard: '',
      AankoopDatum: '',
      Bearlock: '',
      Branche: '',
      BpmVerrekenen: false,
      BtwVerrekenen: '',
      BezorgBrommer: '',
      vehicleload: '',
      EersteAutoDagelijksGebruik: '',
      standplaatsIsInGroteStad: '',
      grensoverschrijdendvervoer: '',
      Gebruik: '',
      GebruikInBuitenlandLangerDanZesMaanden: '',
      GebruiktAlsVerkoopwagen: '',
      HobbymatigGebruik: '',
      IsZzp: '',
      ProvisieKey: '',
      Eigenaar: '',
      KentekenHouder: '',
      KentekenAutoEersteGebruik: '',
      KentekenhouderAutoEersteGebruik: '',
      LeaseAuto: '',
      oldtimer: '',
      RedenVanAanvraag: '',
      StallingInBuitenland: '',
      ToelichtingZakelijkGebruik: '',
      VerhuurMeeverzekeren: '',
      IngangsDatum: '',
      verhuur: '',
      totJaar: '',
      huidigJaar: '',
      soort: '',

      // (Bestel)auto
      transportOwnGoods: '',

      // Camper
      Keurmerk: '',
      TaxatieRapport: '',
      TaxatieDatum: '',

      // Motorfiets
      MinimaalVerzekerdBedragAccessoires: '',
      MinimaalVerzekerdBedragHelmKledingSchoenen: '',

      // InsuretoStudy
      sbiCode: '',

      // Caravan
      EersteEigenaar: '',
      Lengte: '',
      Standplaats: '',
      StormMeeverzekeren: '',
      BeschadigingMeeverzekeren: '',
      Aanschafjaar: '',
      Aanbouwwaarde: '',
      Inboedelwaarde: '',
      InGebruikAlsStacaravan: '',
      VoortentLuifelwaarde: '',
      HagelbestendigDak: '',
      Moverwaarde: '',
      PermanentBewoond: '',
      HagelMeeverzekeren: '',
      Brandschade: '',
      Diefstalschade: '',
      luifelwaarde: '',
      MinimaleGarantieTermijnInMaanden: '',

      // Aanhangwagen
      MetKenteken: '',

      Bedrijfsactiviteit: '',
      DagwaardeTrailer: '',
      EigenBouw: '',
      // Bouwaard: '', is carrosserie binnen voertuig store
      BouwaardAnders: '',
      EigenRisico: '',
      GebruikInWedstrijden: '',
      GewenstVaargebied: '',
      HeeftVaartuigVolgsysteem: '',
      InBezitVanVaarbewijs: '',
      LengteInCm: '',
      LengteVolgboot: '',
      Ligplaats: '',
      LigplaatsStraatnaam: '',
      LigplaatsHuisnummer: '',
      LigplaatsPostcode: '',
      LigplaatsWoonplaats: '',
      LigplaatsToevoeging: '',
      LigplaatsAdresStalling: '',
      LigplaatsAnderePlaats: '',
      LigplaatsJachthavenOfWatersportvereniging: '',
      LigplaatsPlaatsStalling: '',
      LigplaatsStallingAfgeslotenRuimte: '',
      LigplaatsStallingAfgeslotenTerrein: '',
      LigplaatsToezicht: '',
      medeEigenaarAanwezig: '',
      medeEigenaarVoornaam: '',
      medeEigenaarTussenvoegsels: '',
      medeEigenaarAchternaam: '',
      medeEigenaarGeboortedatum: '',
      MotorvermogenVolgbootMeerDan10Pk: '',
      NieuwwaardeTrailer: '',
      NieuwwaardeVerlengen: '',
      RedenAantalSchadevrijeJaren: '',
      RedenAantalSchadevrijeJarenAnders: '',
      RedenDagelijksGebruikAnders: '',
      TrailerBouwjaar: '',
      TrailerKenteken: '',
      TrailerMeeverzekeren: '',
      TrailerMerk: '',
      TrailerMerkEnType: '',
      TrailerVoertuigIdentificatienummer: '',
      TrailerZwaarderDan750Kg: '',
      TypeVaartuig: '',
      VaartuigAankoopnotaAanwezig: '',
      VaartuigBouwjaarMotor: '',
      VaartuigCinHinNummer: '',
      VaartuigInAanbouw: '',
      VaartuigMerk: '',
      VaartuigLengte: '',
      VaartuigMerkTypeMotor: '',
      VaartuigMotorAandrijving: '',
      VaartuigMotorInBun: '',
      VaartuigMotornummer: '',
      VaartuigNaam: '',
      VaartuigRegistratienummer: '',
      VaartuigSnellerDan20kmph: null,
      VaartuigType: '',
      VaartuigRegistratieLand: '',
      VolgbootBouwaard: '',
      VolgbootBouwjaar: '',
      VolgbootBouwjaarMotor: '',
      VolgbootCinHinNummer: '',
      VolgbootMeeverzekeren: '',
      VolgbootMerk: '',
      VolgbootMerkTypeMotor: '',
      VolgbootMotornummer: '',
      VolgbootMotorvermogen: '',
      VolgbootType: '',
      WaardeVolgboot: '',
    },
    bedrijfspand: {
      // gebouw
      bouwaard: '',
      gebouwtypeLuxeM2Waarde: '',
      gebouwtypeMinimaleM2Waarde: '',
      gebouwtypeNaam: '',
      herbouwwaarde: '',
      oppervlakte: '',
      schattingHerbouwwaarde: '',

      // bedrijf
      bedrijfsbranche: '',
      voorkeurstijdTelefonischContact: '',
    },
    aansprakelijkheid: {
      IngangsDatum: '',
      Hennepkwekerij: '',
      MaximaalEigenRisico: 0,
      MaximaalEigenRisicoKinderen: 0,
      VerzekerdBedrag: null,
    },
    inboedel: {
      IngangsDatum: '',
      GlasMeeverzekeren: '0',
      Hennepkwekerij: '',
      Huurdersbelang: 0,
      MaximaalEigenRisico: 150,
      MaximaalEigenRisicoStorm: 450,
      MinimaalVerzekerdBedragAudioVisueleApparatuur: '',
      MinimaalVerzekerdBedragBuitenshuis: '',
      MinimaalVerzekerdBedragKunstAntiekSchilderijen: 0,
      MinimaalVerzekerdBedragLijfsieraden: '',
      MinimaalVerzekerdBedragMuziekinstrumenten: 0,
      MinimaalVerzekerdBedragVerzamelingen: 0,
      MinimaleDekkingsvorm: 'MeestUitgebreid',
      MobieleElektronicaMeeverzekeren: '',
      NieuwwaardeVolledigeInboedel: '',
      MinimaalVerzekerdBedragEigenarenbelang: '',
      EigenaarSinds: '',
    },
    woonhuis: {
      IngangsDatum: '',
      GlasMeeverzekeren: '',
      Hennepkwekerij: '',
      Herbouwwaarde: '',
      MaximaalEigenRisico: 150,
      MaximaalEigenRisicoStorm: 450,
      MinimaleDekkingsvorm: 'MeestUitgebreid',
      ZonnepanelenMeeverzekeren: '',
      BijgebouwenMeeverzekeren: '',
      OppervlakteBijgebouwen: '',
      LeegstaandJaren: '',
      RedenLeegstaand: '',
      StaatTeKoop: '',
      BrandPreventieMaatregelen: '',
      ToezichtLeegstaand: '',
      Verkoopwaarde: '',
      NutsvoorzieningenDoorlopend: '',
      HypotheekStaat: '',
      GarantieOnderverzekering: '',
      HeeftGrootBijgebouw: '',
      VerzekerdBedragBijgebouw: '',
      GebruikBijgebouw: '',
      GebruikBijgebouwAnders: '',
      BouwaardMurenBijgebouw: '',
      BouwaardMurenBijgebouwAnders: '',
      BouwaardDakBijgebouw: '',
      BouwaardDakBijgebouwAnders: '',
      Bouwjaar: '',
      TypeWoning: '',
      InhoudWoning: '',
      Fundering: '',
      DakEnConstructie: '',
      DakisolatieHogerDanStandaard: '',
      GevelisolatieHogerDanStandaard: '',
      AfbouwEnAfwerking: '',
      Zonnepanelen: ''
    },
    rechtsbijstand: {
      IngangsDatum: '',
      Hennepkwekerij: '',
      ArbeidsrechtMeeverzekeren: '',
      BurenrechtMeeverzekeren: '',
      ConsumentMeeverzekeren: '1',
      FiscaalEnVermogenMeeverzekeren: '',
      InkomenMeeverzekeren: '',
      MaximaalEigenRisico: '',
      MaximaleFranchise: 175,
      MediationMeeverzekeren: '',
      MinimaalVerzekerdBedragVrijeAdvocaatkeuze: 0,
      MotorrijtuigenMeeverzekeren: '',
      PleziervaartuigenMeeverzekeren: '',
      VerkeerMeeverzekeren: '',
      WonenMeeverzekeren: '',
      vrijeAdvocaatkeuze: '',
    },
    doorlopendereis: {
      IngangsDatum: '',
      Hennepkwekerij: '',
      AnnuleringMeeverzekeren: '',
      AutomobilistenhulpMeeverzekeren: '',
      AvontuurlijkeSportMeeverzekeren: false,
      MaximaalEigenRisico: 0,
      MedischeKostenMeeverzekeren: '',
      MinimaalAantalDagen: '',
      MinimaalDekkingsgebied: '',
      MinimaalVerzekerdBedragAnnulering: '',
      MinimaalVerzekerdBedragBagage: '',
      MinimaalVerzekerdBedragGeld: '',
      OnderwatersportMeeverzekeren: '',
      OngevallenMeeverzekeren: '',
      RechtsbijstandMeeverzekeren: '',
      SamengesteldeReisMeeverzekeren: '',
      WintersportMeeverzekeren: '',
      ZakenreisMeeverzekeren: '',
    },
    gezinsongevallen: {
      IngangsDatum: '',
      Hennepkwekerij: '',
      GeboortedatumPartner: '',
      MinimaalAantalVerzekerdePersonenBeroepswerkzaamheden: '',
      MinimaalVerzekerdBedragInvaliditeit: '',
      MinimaalVerzekerdBedragOverlijden: '',
    },
    insuretostudy: {
      Collectiviteit: '',
      InstellingsCode: '',
      OnderwijsInstelling: '',
      EduOverig: '',
      LandOorsprong: '',
      LandBestemming: '',
      DatumVertrek: '',
      DatumTerug: '',
      EHIC: '',
      KopieerAanvragerNaarHerkomst: '',
      HerkomstStraat: '',
      HerkomstHuisnummer: '',
      HerkomstToevoeging: '',
      HerkomstPostcode: '',
      HerkomstWoonplaats: '',
      BestemmingStraat: '',
      BestemmingHuisnummer: '',
      BestemmingToevoeging: '',
      BestemmingPostcode: '',
      BestemmingWoonplaats: '',
    },
  }),
  getters: {
    itsLandBestemming: (state) => state.insuretostudy.LandBestemming,
  },
  actions: {
    setAantalSchadevrijeJaren(value) {
      this.voertuig.AantalSchadevrijeJaren = value;
    },
    setBpmVerrekenen(value) {
      this.voertuig.BpmVerrekenen = value;
    },
    setAantalKmPerJaar(value) {
      this.voertuig.AantalKmPerJaar = value;
    },
    setHennepKwekerij(val) {
      const verzekering = verzekeringStore();
      Object.keys(verzekering.verzekering).forEach((insuranceType) => {
        this[insuranceType.toLowerCase()].Hennepkwekerij = val;
      });
    },
    setInvalidewagenValues(premium) {
      const pakket = pakketStore();
      if (pakket.module === 'invalidewagen') {
        this.voertuig.totJaar = premium.maatschappij.match(/(unigarant|klaverblad)/i) ? premium.totJaar : '';
        this.voertuig.huidigJaar = premium.maatschappij.match(/(unigarant|klaverblad)/i) ? premium.premieHuidigJaar : '';
        this.voertuig.AantalSchadevrijeJaren = '';
      }
    },
    setGebouwtypeNaam(value) {
      if (!value) {
        this.bedrijfspand.gebouwtypeNaam = '';
        this.bedrijfspand.gebouwtypeLuxeM2Waarde = '';
        this.bedrijfspand.gebouwtypeMinimaleM2Waarde = '';
        return;
      }

      const { buildingTypeValues, buildingRebuildValue } = useBuildingDetails(this.bedrijfspand);

      this.bedrijfspand.gebouwtypeNaam = value;
      this.bedrijfspand.gebouwtypeLuxeM2Waarde = buildingTypeValues[value].luxuryConstructionPrice;
      this.bedrijfspand.gebouwtypeMinimaleM2Waarde = buildingTypeValues[value].minimumConstructionPrice;

      this.bedrijfspand.schattingHerbouwwaarde = buildingRebuildValue;
    },
    setOppervlakte(value) {
      this.bedrijfspand.oppervlakte = value;

      const { buildingRebuildValue } = useBuildingDetails(this.bedrijfspand);
      this.bedrijfspand.schattingHerbouwwaarde = buildingRebuildValue;
    },
    setBouwaard(value) {
      this.bedrijfspand.bouwaard = value;

      const { buildingRebuildValue } = useBuildingDetails(this.bedrijfspand);
      this.bedrijfspand.schattingHerbouwwaarde = buildingRebuildValue;
    },
  },
  persist: true,
});
